import { render, staticRenderFns } from "./VenueDetail.vue?vue&type=template&id=d1ec4394&scoped=true&"
import script from "./VenueDetail.vue?vue&type=script&lang=ts&"
export * from "./VenueDetail.vue?vue&type=script&lang=ts&"
import style0 from "./VenueDetail.vue?vue&type=style&index=0&id=d1ec4394&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ec4394",
  null
  
)

export default component.exports